import { Position } from '@xyflow/react'

/**
 * The four ports a sequence can end at, one per bounding-box side.
 *
 * Every BPMN shape family lands on the same four points: the side centres of an
 * activity's rounded rectangle, the vertices of a gateway diamond (a diamond
 * inscribed in its box touches each side at that side's centre) and the cardinal
 * points of an event circle. So one anchor set covers all of them.
 */
export const TARGET_HANDLE_POSITIONS = [
  Position.Left,
  Position.Top,
  Position.Right,
  Position.Bottom,
] as const

const TARGET_HANDLE_PREFIX = 'connect-target-'

export function targetHandleId(position: Position): string {
  return `${TARGET_HANDLE_PREFIX}${position}`
}

export function targetHandlePosition(handleId: string | null | undefined): Position | undefined {
  return TARGET_HANDLE_POSITIONS.find((position) => targetHandleId(position) === handleId)
}
